import { zoom } from "../../components/zoom/zoom";
import { centerAndZoomFeature, zoomToFeature } from "../../utils/zoom";
/**@category utilities */
export function zoomToFeatureOnMap(settings) {
    zoomToFeature({
        mapView: settings.mapView,
        geometry: settings.geometry,
        duration: settings.duration,
        easing: settings.easing,
        zoom: settings.zoom
    });
}
/**@category esri widgets */
export function zoomWidget(zoomSettings) {
    zoom(zoomSettings);
}
/**@category utilities */
export function centerAndZoom(centerFeature) {
    centerAndZoomFeature(centerFeature);
}
